import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { getDefaultHeaderHeight, Header, HeaderBackButton, HeaderTitle } from "@react-navigation/elements";
import * as React from "react";
import { Platform, StyleSheet } from "react-native";
import memoize from "../../utils/memoize";
export default function HeaderSegment(props) {
    var _React_useState = _sliced_to_array(React.useState(undefined), 2), leftLabelLayout = _React_useState[0], setLeftLabelLayout = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(undefined), 2), titleLayout = _React_useState1[0], setTitleLayout = _React_useState1[1];
    var handleTitleLayout = function(e) {
        var _e_nativeEvent_layout = e.nativeEvent.layout, height = _e_nativeEvent_layout.height, width = _e_nativeEvent_layout.width;
        setTitleLayout(function(titleLayout) {
            if (titleLayout && height === titleLayout.height && width === titleLayout.width) {
                return titleLayout;
            }
            return {
                height: height,
                width: width
            };
        });
    };
    var handleLeftLabelLayout = function(e) {
        var _e_nativeEvent_layout = e.nativeEvent.layout, height = _e_nativeEvent_layout.height, width = _e_nativeEvent_layout.width;
        if (leftLabelLayout && height === leftLabelLayout.height && width === leftLabelLayout.width) {
            return;
        }
        setLeftLabelLayout({
            height: height,
            width: width
        });
    };
    var getInterpolatedStyle = memoize(function(styleInterpolator, layout, current, next, titleLayout, leftLabelLayout, headerHeight) {
        return styleInterpolator({
            current: {
                progress: current
            },
            next: next && {
                progress: next
            },
            layouts: {
                header: {
                    height: headerHeight,
                    width: layout.width
                },
                screen: layout,
                title: titleLayout,
                leftLabel: leftLabelLayout
            }
        });
    });
    var progress = props.progress, layout = props.layout, modal = props.modal, onGoBack = props.onGoBack, title = props.headerTitle, tmp = props.headerLeft, left = tmp === void 0 ? onGoBack ? function(props) {
        return /*#__PURE__*/ _jsx(HeaderBackButton, _object_spread({}, props));
    } : undefined : tmp, right = props.headerRight, headerBackImage = props.headerBackImage, headerBackTitle = props.headerBackTitle, _props_headerBackTitleVisible = props.headerBackTitleVisible, headerBackTitleVisible = _props_headerBackTitleVisible === void 0 ? Platform.OS === "ios" : _props_headerBackTitleVisible, headerTruncatedBackTitle = props.headerTruncatedBackTitle, headerBackAccessibilityLabel = props.headerBackAccessibilityLabel, headerBackTestID = props.headerBackTestID, headerBackAllowFontScaling = props.headerBackAllowFontScaling, headerBackTitleStyle = props.headerBackTitleStyle, headerTitleContainerStyle = props.headerTitleContainerStyle, headerLeftContainerStyle = props.headerLeftContainerStyle, headerRightContainerStyle = props.headerRightContainerStyle, headerBackgroundContainerStyle = props.headerBackgroundContainerStyle, customHeaderStyle = props.headerStyle, headerStatusBarHeight = props.headerStatusBarHeight, styleInterpolator = props.styleInterpolator, rest = _object_without_properties(props, [
        "progress",
        "layout",
        "modal",
        "onGoBack",
        "headerTitle",
        "headerLeft",
        "headerRight",
        "headerBackImage",
        "headerBackTitle",
        "headerBackTitleVisible",
        "headerTruncatedBackTitle",
        "headerBackAccessibilityLabel",
        "headerBackTestID",
        "headerBackAllowFontScaling",
        "headerBackTitleStyle",
        "headerTitleContainerStyle",
        "headerLeftContainerStyle",
        "headerRightContainerStyle",
        "headerBackgroundContainerStyle",
        "headerStyle",
        "headerStatusBarHeight",
        "styleInterpolator"
    ]);
    var defaultHeight = getDefaultHeaderHeight(layout, modal, headerStatusBarHeight);
    var _StyleSheet_flatten = StyleSheet.flatten(customHeaderStyle || {}), _StyleSheet_flatten_height = _StyleSheet_flatten.height, height = _StyleSheet_flatten_height === void 0 ? defaultHeight : _StyleSheet_flatten_height;
    var _getInterpolatedStyle = getInterpolatedStyle(styleInterpolator, layout, progress.current, progress.next, titleLayout, headerBackTitle ? leftLabelLayout : undefined, typeof height === "number" ? height : defaultHeight), titleStyle = _getInterpolatedStyle.titleStyle, leftButtonStyle = _getInterpolatedStyle.leftButtonStyle, leftLabelStyle = _getInterpolatedStyle.leftLabelStyle, rightButtonStyle = _getInterpolatedStyle.rightButtonStyle, backgroundStyle = _getInterpolatedStyle.backgroundStyle;
    var headerLeft = left ? function(props) {
        return left(_object_spread_props(_object_spread({}, props), {
            backImage: headerBackImage,
            accessibilityLabel: headerBackAccessibilityLabel,
            testID: headerBackTestID,
            allowFontScaling: headerBackAllowFontScaling,
            onPress: onGoBack,
            label: headerBackTitle,
            truncatedLabel: headerTruncatedBackTitle,
            labelStyle: [
                leftLabelStyle,
                headerBackTitleStyle
            ],
            onLabelLayout: handleLeftLabelLayout,
            screenLayout: layout,
            titleLayout: titleLayout,
            canGoBack: Boolean(onGoBack)
        }));
    } : undefined;
    var headerRight = right ? function(props) {
        return right(_object_spread_props(_object_spread({}, props), {
            canGoBack: Boolean(onGoBack)
        }));
    } : undefined;
    var headerTitle = typeof title !== "function" ? function(props) {
        return /*#__PURE__*/ _jsx(HeaderTitle, _object_spread_props(_object_spread({}, props), {
            onLayout: handleTitleLayout
        }));
    } : function(props) {
        return title(_object_spread_props(_object_spread({}, props), {
            onLayout: handleTitleLayout
        }));
    };
    return /*#__PURE__*/ _jsx(Header, _object_spread({
        modal: modal,
        layout: layout,
        headerTitle: headerTitle,
        headerLeft: headerLeft,
        headerLeftLabelVisible: headerBackTitleVisible,
        headerRight: headerRight,
        headerTitleContainerStyle: [
            titleStyle,
            headerTitleContainerStyle
        ],
        headerLeftContainerStyle: [
            leftButtonStyle,
            headerLeftContainerStyle
        ],
        headerRightContainerStyle: [
            rightButtonStyle,
            headerRightContainerStyle
        ],
        headerBackgroundContainerStyle: [
            backgroundStyle,
            headerBackgroundContainerStyle
        ],
        headerStyle: customHeaderStyle,
        headerStatusBarHeight: headerStatusBarHeight
    }, rest));
}
